import { render, staticRenderFns } from "./NetaHeaderComponent.vue?vue&type=template&id=6db5beae&scoped=true&"
import script from "./NetaHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./NetaHeaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaHeaderComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NetaHeaderComponent.vue?vue&type=style&index=1&id=6db5beae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db5beae",
  null
  
)

export default component.exports